import { eventNames, useCoreEvents } from '@carvana/core-events';
import { useEffect } from 'react';
import { useUserLocation } from '~/context/common/UserContext';

export default function useSyncGeolocation(): void {
  const { emit } = useCoreEvents();
  const { zip } = useUserLocation();

  // Alert Favorites MFE if geolocation changes
  useEffect(() => {
    emit(eventNames.favorites.mfe.refresh, {
      source: 'app',
      changed: 'geolocation'
    });
  }, [emit, zip]);
}
